module.exports = __webpack_public_path__ + "assets/img/head4-zh.eab0ea3b.png";